 import * as constants from './constants';
 import userRequest, {
     userApi
 } from 'common/request';
  import { Toast } from 'antd-mobile';
 const changeLabContent = (lab) => ({
     type: constants.CHANGE_LAB_CONTENT,
     lab
 })
 const changeAttachmentList = (attachmentList) => ({
     type: constants.CHANGE_ATTACHMENT_LIST,
     attachmentList
 })
 const changeGradeTpl = (grade_tpl, grade_tpl_content) => ({
     type: constants.CHANGE_GRADE_TPL,
     grade_tpl,
     grade_tpl_content
 })
 

 const changeSubjectInfo = (subjectInfo) => ({
     type: constants.CHANGE_SUBJECT_INFO,
     subjectInfo
 });
 const changeMySubRecord = (mySubRecord)=>({
    type:constants.CHANGE_MY_SUB_RECORD,
    mySubRecord
 })
 const changeMyScore = (score)=>({
    type:constants.CHANGE_MY_SCORE,
    score
})
const changeMyRecoreContent = (recordContent,recordAll)=>({
    type:constants.CHANGE_MY_RECORD_CONTENT,
    recordContent,
    recordAll
})
export const changeRecordAll = (recordAll)=>({
    type:constants.CHANGE_RECORD_ALL,
    recordAll
})

 export const getSubjectInfo = (course_id, sub_id) => {
     return (dispatch) => {
         userRequest.get(window.AppConfig.mainIP + userApi.getSubjectInfo, {
             course_id,
             sub_id
         }).then((res) => { 
             if (res.code === 0) {

                 dispatch(changeSubjectInfo(res.data));
                 if (res.data.content) {
                     if (res.data.content.attachments) {
                       let attachments ={}
                        try
                          {
                          //在这里运行代码
                             attachments = JSON.parse(res.data.content.attachments);
                          }
                        catch(err)
                          {
                          //在这里处理错误
                            attachments ={}
                          }
                          dispatch(changeAttachmentList(attachments));
                       
                     }

                     let grade_tpl ={};
                     let grade_tpl_content ={};
                     if (res.data.content.grade_tpl ) {
                         grade_tpl = JSON.parse(res.data.content.grade_tpl) 
                         grade_tpl_content = JSON.parse(grade_tpl.content);
                        
                     } 
                         
                      dispatch(changeGradeTpl(grade_tpl, grade_tpl_content))
                     if (res.data.content.lab) {
                        
                         let lab = JSON.parse(res.data.content.lab)
                         dispatch(changeLabContent(lab))
                     }else{
                        dispatch(changeLabContent({}))
                     }
                 }else{
                     dispatch(changeAttachmentList({}));
                     dispatch(changeGradeTpl({}))
                     dispatch(changeLabContent({}))
                 }
             }
         })
     }
 }
export const getMySubRecord = (user_id, sub_id)=>{
    return (dispatch)=>{
        userRequest.get(window.AppConfig.mainIP + userApi.getMySubRecord, {
             user_id,
             sub_id
         }).then((res) => {
            
             if (res.code === 0) {
                  
                  if(res.data.score===undefined){
                    dispatch(changeMySubRecord(''))
                    dispatch(changeMyScore(''))

                  } 
                   
                    if(res.data.content&&res.data.content.length!=0){ 
                        let content = res.data.content;
                        let reportAll=[]
                        if(JSON.parse(content).report){
                          reportAll = [JSON.parse(content).report,...JSON.parse(content).attach];
                        } 
                         dispatch(changeMyRecoreContent(JSON.parse(content),reportAll))
                    }else{
                         dispatch(changeMyRecoreContent({
                                                report:{},
                                                attach:[]
                                            },[]))
                    }
                    if(res.data.score){
                        dispatch(changeMyScore(res.data.score))
                    }else{
                        dispatch(changeMyScore(''))
                    }
                    dispatch(changeMySubRecord(res.data))
                  }
                
             
         })
    }
}

//添加报告 
export const addReport = (res,user_id,user_name,course_id,sub_id)=>{
    return (dispatch)=>{ 
  
     userRequest.post(window.AppConfig.mainIP + userApi.addReport, {
        res:res,
        user_id , 
        username:user_name,     
        tenant:localStorage.getItem('tenant_code'),
        course_id ,
        sub_id
     }).then((res) => {
        console.log('addreport',res)
         if (res.code === 0) {   
       
             Toast.success('添加成功', 2);
         }else{
             
            Toast.fail('添加失败', 2);
         }
     }) 
  }
     
}